import type { StorageFolder } from '@/domain/shared/media';

export const FileRequestType = {
  GetImageUrls: 'getImageUrls',
  UploadImage: 'uploadImage',
  DeleteImage: 'deleteImage',
  DeleteImages: 'deleteImages',
} as const;

export type FileRequestType = (typeof FileRequestType)[keyof typeof FileRequestType];

export type SignedMediaUrlLookup = Record<string, string>;

export interface GetImageUrlsRequest {
  requestType: typeof FileRequestType.GetImageUrls;
  propertyID: string;
  folder: StorageFolder;
  filesKeys: string[];
}

export type GetImageUrlsResponse = SignedMediaUrlLookup;

export interface UploadImageRequest {
  requestType: typeof FileRequestType.UploadImage;
  propertyID: string;
  folder: StorageFolder;
  fileName: string;
  fileContent: string;
  contentType: string;
}

export interface UploadImageResponse {
  message: 'UploadSuccess';
  data: {
    signedUrl: string;
  };
}

export interface DeleteImageResponse {
  message: 'DeleteSuccess';
  data: {
    mediaDeleted: Record<string, string>;
  };
}

export interface DeleteImagesRequest {
  requestType: typeof FileRequestType.DeleteImages;
  propertyID: string;
  folder: StorageFolder;
  filesKeys: string[];
}

export type DeleteImagesResponse = Record<string, string>;
